import React from 'react';
import { Link } from 'react-router-dom';

import './App.scss';

class App extends React.Component{
    state = { 
        faq: [
            {
              question: "When will be the masterclass ?",
              answer: "Once you reserve your seat, you will immediately get an email with details of date time along with your login credentials.",
              showAns: false,
            },
            {
              question: "Is it worth Investing ₹ 1900 for this workshop",
              answer: `Absolutely YES, here are the reasons:
              Top companies like Zomoto, Swiggy, Paytm, Google Pay, 
              Netflix etc are aggressively hiring App Marketing Professionals
              App marketing Manager earn on an average ₹ 12 Lakhs 
              salary per annum 
              App Marketing is one of the fastest career path in the 
              corporate ladder.
               
              You will get all these  benefits just at the price of a Pizza party with 
              friends.`,
              showAns: false,
            },
            {
              question: "Do we need to buy any paid tools?",
              answer: `NO, you need not buy anything. We will provide you the package 
              free of cost.`,
              showAns: false,
            },
            {
              question: "When will I be able to unlock my bonuses",
              answer: `Once the workshop is complete, you will get the details `,
              showAns: false,
            },
            {
              question: "How will I get the Certificate ?",
              answer: `At the end of the session an email with link to signed certificate 
              will be sent to you.`,
              showAns: false,
            },
            {
              question: "Is this a pre-recorded session ?",
              answer: `NO, this is hands on practical model building LIVE session by trainers 
              currently working in top companies`,
              showAns: false,
            },
            {
              question: "How can I contact if I have any questions or issues ?",
              answer: `Please send us an email to social@moatschool.live. We will be glad to help.`,
              showAns: false,
            },
            {
              question: "Can I refer my friends to this workshop ?",
              answer: `Yes. However, please note, as a policy we admit only few students 
              so that our trainers can focus and hand hold each and every 
              students in this live session. `,
              showAns: false,
            },
        ],
        checkoutUrl: ``, 
        assets: '/assets/azure-workshop/',
        reviews: [
            {
                name: "Shashank D",
                image: "/assets/azure-workshop/review/shashank.png",
                alt: "shashank",
                review: "Never experience such a high quality online learning. Kudos to the team.",
                line: "/assets/azure-workshop/review/line.png"
            },
            {
                name: "Aditya Zalte",
                image: "/assets/azure-workshop/review/aaditya.png",
                alt: "aaditya",
                review: "I had best training experience with Moat School, especially the projects were really amazing",
                line: "/assets/azure-workshop/review/line.png"
            },
            {
                name: "Anushree Singh",
                image: "/assets/azure-workshop/review/anushree.png",
                alt: "anushree",
                review: "Excellent course. Best instructor-led course I have attended, by far. All the deliverables were perfectly met.",
                line: "/assets/azure-workshop/review/line.png"
            },
            {
                name: "Sunil Choudhari",
                image: "/assets/azure-workshop/review/sunil.png",
                alt: "sunil",
                review: "The way they organized their content and the way they teach is really good",
                line: "/assets/azure-workshop/review/line.png"
            },

        ],
        timer: ''
    }

    startTimer = () => {
        setInterval(()=>{ 
            var toDate=new Date();
            var tomorrow=new Date();
            tomorrow.setHours(24,0,0,0);
            var diffMS=tomorrow.getTime()/1000-toDate.getTime()/1000;
            var diffHr=Math.floor(diffMS/3600);
            diffMS=diffMS-diffHr*3600;
            var diffMi=Math.floor(diffMS/60);
            diffMS=diffMS-diffMi*60;
            var diffS=Math.floor(diffMS);
            var result=((diffHr<10)?"0"+diffHr:diffHr);
            result+=":"+((diffMi<10)?"0"+diffMi:diffMi);
            result+=":"+((diffS<10)?"0"+diffS:diffS);
            this.setState({ timer: result})
            
          },1000);
    }
    
    componentDidMount() {
        window.scroll(0, 0);
        this.startTimer();
    }

    testimonial = () => {
        let testimonial = this.state.reviews;
        return (
            testimonial.map((review, i) => {
                return (
                    <div className="review__container__card" key={i} >
                        <img loading="auto"  className="review__container__card--comma"
                            src={`/assets/azure-workshop/review/comma.png`} alt="comma" />
                        <div className="review__container__card__name" >
                            <img loading="auto"  src={review.image} className="review__container__card__name--p" alt="review" />
                            <img loading="auto" src={review.line} className="review__container__card__name--line" alt="line" />
                            <h5>{review.name}</h5>
                        </div>
                        <div className="review__container__card--review">
                            <h6>{review.review}</h6>
                        </div>
                    </div>
                )

            })
        )
    }

    render(){
        return(
            <React.Fragment>
                <a href="http://wa.me/918088426734" target="__blank" className="sticky__whatsApp" >
                    Question? Connect on 
                    <img src="https://businesstoys.in/assets/cbc-2/images/whatsapp.png" alt="whatsapp" />
                    Whatsapp! 
                </a>
                <header className='aM__header' >
                    <div className='aM__header__txt'>
                        <h1>
                            Certificate in Fundamentals of 
                            <span>
                                &nbsp; Azure for Data Science
                            </span>
                        </h1>
                        <img loading="auto" className='tabletOff aM__header__txt--mentor' src={this.state.assets + 'mentor-mobile.png'} alt="Manikanta | Business Toys" />
                        <p>
                            <img loading="auto" className='tabletOn' src={this.state.assets + 'tick.png'} alt="tick" />
                            Every Data Scientist Must know
                        </p>
                        <p>
                            <img loading="auto" className='tabletOn' src={this.state.assets + 'tick.png'} alt="tick" />
                            Learn most in demand skill in the industry today
                        </p>
                        <Link to="/checkout" className='tabletOff' target="__blank"  >
                            Reserve Seat for ₹ 7,999 &nbsp; 
                            <span>
                                ₹ 15,000 
                            </span>
                        </Link>
                        <span className='tabletOff aM__header__txt--timer' > Offer valid till {this.state.timer}</span>
                    </div>
                    <div className='aM__header__img tabletOff'>
                        <img loading="auto"src={this.state.assets + 'mentor.png'} alt="Manikanta | Business Toys"  />
                    </div>
                </header>
                <section className='aM__companies' >
                    <h2>We have had participants from top companies like</h2>
                    <img loading="auto"className='aM__companies--web' src={this.state.assets + 'companies.png'} alt="companies" />
                    <img loading="auto"className='aM__companies--mobile' src={this.state.assets + 'companies-mobile.png'} alt="companies" />
                </section>
                <section className='aM__video'>
                    <h2>All about the certification program</h2>
                    <div className='aM__video__container' >
                        
                        <div className='aM__video__txt' >
                            <div className='aM__video__txt--box' >
                                <p>
                                    <img loading="auto" src={this.state.assets + 'clock.png'} alt="clock" />
                                    15 Hours Instructor lead live session
                                </p>
                                <p>
                                    <img loading="auto" src={this.state.assets + 'calendar.png'} alt="clock" />
                                    Starts from 10th Dec 2022
                                </p>
                                
                            </div>
                        </div>
                    </div>
                </section>
                <section className='aM__learn'>
                    <h2>What you will learn ?</h2>
                    <div className='aM__learn__container'>
                        <div className='aM__learn__container--card' >
                            <img loading="auto"src={this.state.assets + 'week-1.png'}  alt="week 1" />
                        </div>
                        <div className='aM__learn__container--card' >
                            <img loading="auto"src={this.state.assets + 'week-2.png'}  alt="week 1" />
                        </div>
                        <div className='aM__learn__container--card' >
                            <img loading="auto"src={this.state.assets + 'week-3.png'}  alt="week 1" />
                        </div>
                        <div className='aM__learn__container--card' >
                            <img loading="auto"src={this.state.assets + 'week-4.png'}  alt="week 1" />
                        </div>
                        <div className='aM__learn__container--card' >
                            <img loading="auto"src={this.state.assets + 'week-5.png'}  alt="week 1" />
                        </div>
                    </div>
                    <a href='https://businesstoys.in/assets/azure-workshop/brochure.pdf' target="__blank" >Download Brochure</a>
                </section>
                <section className='aM__workshop'>
                    <h2>Key Takeaways </h2>
                    <div className='aM__workshop__container' >
                        
                        <div className='aM__workshop__container__txt'>
                            <div className='aM__workshop__container__txt--card' >
                                <img loading="auto"src={this.state.assets + 'w-1.png'} alt="w-1" />
                                <p>
                                    Azure cloud Architecture & Key features
                                </p>
                                
                            </div>
                            <div className='aM__workshop__container__txt--card' >
                                <img loading="auto"src={this.state.assets + 'w-2.png'} alt="w-1" />
                                <p>
                                    Creating Azure Data Factory pipeline
                                </p>
                                
                            </div>
                            <div className='aM__workshop__container__txt--card' >
                                <img loading="auto"src={this.state.assets + 'w-3.png'} alt="w-1" />
                                <p>
                                    Basis of Hadoop 
                                </p>
                            </div>
                            <div className='aM__workshop__container__txt--card' >
                                <img loading="auto"src={this.state.assets + 'w-4.png'} alt="w-1" />
                                <p>
                                    Basis of PySpark
                                </p>
                            </div>
                            <div className='aM__workshop__container__txt--card' >
                                <img loading="auto"src={this.state.assets + 'w-5.png'} alt="w-1" />
                                <p>
                                    Live Project implementation of Azure platform
                                </p>
                            </div>
                            <div className='aM__workshop__container__txt--card' >
                                <img loading="auto"src={this.state.assets + 'w-6.png'} alt="w-1" />
                                <p>
                                    HIVE Data base
                                </p>
                            </div>
                        </div>
                    </div>
                        <Link to="/checkout" target="__blank" >Reserve now</Link>
                </section>
                <section className='aM__who'>
                    <div className='aM__who__txt'>
                        <h2>Why should you take this course ? </h2>
                        <div className='aM__who__txt__container'>
                            <div className='aM__who__txt__card' >
                                In demand skills
                            </div>
                            <div className='aM__who__txt__card' >
                                Preferred by Recruiters 
                            </div>
                            <div className='aM__who__txt__card' >
                                Hands on Cloud platform
                            </div>
                            <div className='aM__who__txt__card' >
                                Exploring new technologies
                            </div>
                            <Link to="/checkout" target="__blank" >Reserve Seat for ₹7,999 &nbsp;<span>₹15,000</span></Link>
                        </div>
                    </div>
                </section>
                
                <section className='aM__growth'>
                    <h2>Tools learnt</h2>
                    <div className='aM__growth__container' >
                        <div className='aM__growth__container__card' >
                            <img loading="auto"src={this.state.assets + 'g-1.png'} alt="growth" />
                            <p>Azure</p>
                        </div>
                        <div className='aM__growth__container__card' >
                            <img loading="auto"src={this.state.assets + 'g-2.png'} alt="growth" />
                            <p>Hadoop</p>
                        </div>
                        <div className='aM__growth__container__card' >
                            <img loading="auto"src={this.state.assets + 'g-3.png'} alt="growth" />
                            <p>HIVE</p>
                        </div>
                        <div className='aM__growth__container__card' >
                            <img loading="auto"src={this.state.assets + 'g-4.png'} alt="growth" />
                            <p>PySpark</p>
                        </div>
                        <div className='aM__growth__container__card' >
                            <img loading="auto"src={this.state.assets + 'g-5.png'} alt="growth" />
                            <p>SAS</p>
                        </div>
                        <div className='aM__growth__container__card' >
                            <img loading="auto"src={this.state.assets + 'g-6.png'} alt="growth" />
                            <p>Azure Data Factory</p>
                        </div>
                        <div className='aM__growth__container__card' >
                            <img loading="auto"src={this.state.assets + 'g-7.png'} alt="growth" />
                            <p>Power BI</p>
                        </div>
                    </div>
                    <Link to="/checkout" target="__blank" >Reserve Seat for ₹7,999 
                        &nbsp; <span>
                            ₹15,000
                        </span>
                    </Link>
                </section>
                <section className="review">
                    <h2>Testimonial</h2>
                    <div className="review__container">
                        {this.testimonial()}
                    </div>
                </section>
                
                <section className='aM__certificate' >
                    <h2>Get Certified and apply for Azure Certified Jobs <span>immediately !</span></h2>
                    <div className='aM__certificate__container' >
                        <div className='aM__certificate__container--img' >
                            <img loading="auto"src={this.state.assets + 'certificate.png'} alt="certificate" />
                        </div>
                        <div className='aM__certificate__container--txt' >
                            <p>
                                <img loading="auto"src={this.state.assets + 'tick-c.png'} alt="tick" />
                                Digitally Signed and Verified Certificate
                            </p>
                            <p>
                                <img loading="auto"src={this.state.assets + 'tick-c.png'} alt="tick" />
                                Easily shareable Certificate
                            </p>
                            <p>
                                <img loading="auto"src={this.state.assets + 'tick-c.png'} alt="tick" />
                                Use this Certificate for career progression
                            </p>
                        </div>
                    </div>
                </section>
                <section className='aM__company' >
                    <h2>Top companies looking  for candidates with Azure knowledge</h2>
                    <img loading="auto"className='tabletOff' src={this.state.assets + 'company.png'} alt="companies" />
                    <img loading="auto"className='tabletOn' src={this.state.assets + 'company-mobile.png'} alt="companies" />
                    <Link to="/checkout"  target="__blank" >Reserve Seat for ₹7,999 <span>₹15,000</span></Link>
                </section>
                <div className="tabletOn" >
                    <section className="aM-sticky__footer" >
                        <div className="aM-sticky__footer--container" >
                            <div className="aM-sticky__footer__txt" >
                                <h2> ₹7,999 <span>₹15,000</span></h2>
                                <h3>Offer Valid till  {this.state.timer}</h3>
                            </div>
                            <div className="aM-sticky__footer__btn" >
                                <Link to="/checkout"  target="__blank"  > Enroll Now </Link>
                            </div>
                        </div>
                    </section>
                </div>
            </React.Fragment>
        )
    }
};

export default App;